import { DialogContent, Dialog } from "@ac-expo/ui-components";
import Link from "next/link";
import environment from "../../environments/environment";

type BecomeExponentProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export function BecomeExponent({ isOpen, setIsOpen }: BecomeExponentProps) {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-h-[calc(100vh-60px)] max-w-[calc(100vw-20px)] overflow-auto bg-white md:max-h-[calc(100vh-120px)] md:max-w-[700px]">
        <h1 className="text-3xl font-bold">Devenir exposant ?</h1>
        <p className="text-base font-normal text-gray-700">
          Vous disposez d&apos;un compte professionnel et souhaitez exposer à
          cet événement ?<br />
          Activez votre profil exposant en vous connectant{" "}
          <Link
            className="text-blue-500 underline"
            href={`${environment.BACKOFFICE_URL}`}
            target="_blank"
          >
            via ce lien
          </Link>{" "}
          et effectuez une demande de participation.
        </p>
      </DialogContent>
    </Dialog>
  );
}
